import {CombinedState, combineReducers, Reducer} from "redux";
import apiErrorReducer from "../app/apiError/reducer";
import {ApiErrorState} from "../app/apiError/types";
import meReducer from "../app/setMe/reducer";
import {SetMeState} from "../app/setMe/types";
import setModalVisibilityReducer from "../app/setModalVisibility/reducer";
import {SetModalVisibilityState} from "../app/setModalVisibility/types";
import setPathnameReducer from "../app/setPathname/reducer";
import {SetPathnameState} from "../app/setPathname/types";
import setSelectedOfferReducer from "../app/setSelectedOffer/reducer";
import {SetSelectedOfferState} from "../app/setSelectedOffer/types";
import loginReducer from "../services/authService/login/reducer";
import {LoginState} from "../services/authService/login/types";
import contactReducer from "../services/contactService/contact/reducer";
import {ContactState} from "../services/contactService/contact/types";
import getContentsReducer from "../services/contentStringService/getContents/reducer";
import {GetContentsState} from "../services/contentStringService/getContents/types";
import answerQuestionReducer from "../services/userService/answerQuestion/reducer";
import {AnswerQuestionState} from "../services/userService/answerQuestion/types";
import applyOfferReducer from "../services/userService/applyOffer/reducer";
import {ApplyOfferState} from "../services/userService/applyOffer/types";
import getLeaderboardReducer from "../services/userService/getLeaderboard/reducer";
import {GetLeaderboardState} from "../services/userService/getLeaderboard/types";
import getMeReducer from "../services/userService/getMe/reducer";
import {GetMeState} from "../services/userService/getMe/types";
import paymentFailReducer from "../services/userService/paymentFail/reducer";
import {PaymentFailState} from "../services/userService/paymentFail/types";
import paymentRequestReducer from "../services/userService/paymentRequest/reducer";
import {PaymentRequestState} from "../services/userService/paymentRequest/types";
import seePopupReducer from "../services/userService/seePopup/reducer";
import {SeePopupState} from "../services/userService/seePopup/types";

export interface IStore {
  // App
  setMe: SetMeState;
  setModalVisibility: SetModalVisibilityState;
  setPathname: SetPathnameState;
  setSelectedOffer: SetSelectedOfferState;
  apiError: ApiErrorState;
  // Auth
  login: LoginState;
  // ContentString
  getContents: GetContentsState;
  // Contact
  contact: ContactState;
  // User
  answerQuestion: AnswerQuestionState;
  applyOffer: ApplyOfferState;
  getLeaderboard: GetLeaderboardState;
  getMe: GetMeState;
  paymentFail: PaymentFailState;
  paymentRequest: PaymentRequestState;
  seePopup: SeePopupState;
}

export const rootReducer: Reducer<CombinedState<IStore>> = combineReducers({
  // App
  setMe: meReducer,
  setModalVisibility: setModalVisibilityReducer,
  setPathname: setPathnameReducer,
  setSelectedOffer: setSelectedOfferReducer,
  apiError: apiErrorReducer,
  // Auth
  login: loginReducer,
  // ContentString
  getContents: getContentsReducer,
  // Contact
  contact: contactReducer,
  // User
  answerQuestion: answerQuestionReducer,
  applyOffer: applyOfferReducer,
  getLeaderboard: getLeaderboardReducer,
  getMe: getMeReducer,
  paymentFail: paymentFailReducer,
  paymentRequest: paymentRequestReducer,
  seePopup: seePopupReducer,
});
